import { Link } from "react-router-dom";
import PageBanner from "../../PageBanner";
import SocialMediaSidebar from "../../SocialMediaSidebar";
import SectionHeader from "../../SectionHeader";
import ScrollToTopButton from "../../ScrollToTopButton";
import SectionHeaderNoPDF from "../../SectionHeaderNoPDF";

const OfferingGrievanceRedressal = () => {
  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="Grievance Redressal"
        breadcrumb={[
          { label: "Home", href: "/" },
          { label: "Offerings" },
        ]}
      />
      <div className="max-w-6xl mx-auto p-4">
        <SectionHeaderNoPDF
          title="Grievance Redressal @ AJEEVI"
          shareUrl="https://swmecom.ajeevi.in/grievance-redressal"
        />
      </div>
      <div>
        <ScrollToTopButton />
      </div>

      {/* Page content */}
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800 text-justify">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Summary Section */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              Summary
            </h4>
            <p className="text-black mb-4 text-lg">
              The Grievance Redressal system provides a streamlined platform for citizens to report waste management issues, ensuring prompt response and resolution. This digital solution enhances municipal responsiveness while building public trust in waste management services.
            </p>
            <p className="text-black text-lg">
              Municipalities and waste management providers using this system achieve higher citizen satisfaction, improved service quality, and data-driven insights for operational improvements through transparent complaint tracking and resolution mechanisms.
            </p>
          </div>

          {/* Introduction Section */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              Introduction
            </h4>
            <p className="text-black mb-4 text-lg">
              Effective waste management requires active citizen participation and responsive service providers. The Grievance Redressal system bridges the gap between residents and municipal authorities, creating a transparent channel for reporting and resolving waste-related issues.
            </p>
            <p className="text-black text-lg">
              By digitizing the complaint management process, this solution ensures no grievance goes unheard while enabling authorities to prioritize and address issues systematically, with full accountability and traceability from report to resolution.
            </p>
          </div>

          {/* Key Features Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-4 text-black">
              Key Features of Grievance Redressal System:
            </h5>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black">
              <li>
                <strong>Multi-Channel Reporting:</strong> Complaints can be submitted via mobile app, web portal, SMS, or phone call
              </li>
              <li>
                <strong>Real-Time Tracking:</strong> Citizens can monitor complaint status through all resolution stages
              </li>
              <li>
                <strong>Automated Workflows:</strong> Intelligent routing of complaints to appropriate departments and personnel
              </li>
              <li>
                <strong>Geotagging:</strong> Precise location mapping of reported issues for accurate service dispatch
              </li>
              <li>
                <strong>Image/Video Uploads:</strong> Visual documentation of issues for better understanding and verification
              </li>
              <li>
                <strong>Escalation Mechanisms:</strong> Automatic escalation for unresolved or time-sensitive complaints
              </li>
            </ul>
          </div>

          {/* Benefits Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-3 text-black">
              Operational Benefits
            </h5>
            <p className="text-black text-lg mb-4">
              Implementing a digital grievance redressal system transforms waste management responsiveness:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>60-80% faster resolution times compared to traditional complaint systems</li>
              <li>40-60% increase in citizen satisfaction with waste services</li>
              <li>Centralized database for analyzing complaint patterns and service gaps</li>
              <li>Reduced operational costs through efficient complaint prioritization</li>
              <li>Improved workforce accountability with tracked response metrics</li>
              <li>Data-driven decisions for service improvements and resource allocation</li>
            </ul>
          </div>

          {/* Implementation Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-3 text-black">
              Implementation Considerations
            </h5>
            <p className="text-black text-lg mb-4">
              Successful grievance redressal system deployment requires:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Integration with existing municipal systems and databases</li>
              <li>Clear service level agreements for response and resolution times</li>
              <li>Staff training on system use and complaint management protocols</li>
              <li>Public awareness campaigns to promote system adoption</li>
              <li>Multi-language support for diverse communities</li>
              <li>Regular system evaluation and process refinements</li>
            </ul>
          </div>

          {/* Ajeevi's Contribution Section */}
          <div>
            <h5 className="text-xl font-semibold mb-3 text-black">
              Ajeevi's Grievance Redressal Solutions
            </h5>
            <p className="text-black mb-4 text-lg">
              Ajeevi offers comprehensive grievance management solutions tailored for waste management:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>
                <strong>Unified Complaint Platform:</strong> Single system for all waste-related grievances across a municipality
              </li>
              <li>
                <strong>Mobile Workforce App:</strong> Field staff application for receiving, processing, and closing complaints
              </li>
              <li>
                <strong>Analytics Dashboard:</strong> Real-time monitoring of complaint volumes, types, and resolution rates
              </li>
              <li>
                <strong>Automated Notifications:</strong> SMS and push notifications to keep citizens informed at each stage
              </li>
              <li>
                <strong>Integration with GIS:</strong> Visual mapping of complaint hotspots for targeted interventions
              </li>
            </ul>
            <p className="text-black text-lg">
              Discover how Ajeevi's Grievance Redressal system can enhance your waste management services. Visit{" "}
              <a
                href="http://www.ajeevi.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#00D084] hover:underline"
              >
                www.ajeevi.com
              </a>{" "}
              for more information.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default OfferingGrievanceRedressal;